"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const isNil_1 = __importDefault(require("lodash-es/isNil"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const InputText = react_1.default.forwardRef(({ value, onChange, uncontrolled, type, placeholder, ...props }, ref) => {
    const handleChange = (0, react_1.useCallback)((event) => {
        if (onChange) {
            onChange(String(event.target.value), event);
        }
    }, [onChange]);
    return ((0, jsx_runtime_1.jsx)("input", { ...props, className: styles_module_css_1.default.field, ref: ref, type: type, placeholder: placeholder ? String(placeholder) : undefined, ...(!uncontrolled && { value: String((0, isNil_1.default)(value) ? '' : value) }), onChange: handleChange }));
});
exports.default = InputText;
